<template>
  <div class="service-list">
    <headerNotice routerName="退款列表"></headerNotice>
    <!-- 搜索框 -->
    <div class="seach-box">
      <div class="title-wrapper">
        <h2 class="title">
          <i></i>
          <span>筛选查询</span>
        </h2>
        <!-- <el-button class="search-btn" @click="toSearch">查询结果</el-button> -->
      </div>
      <div class="input-wrapper">
        <div>
          <span>客户名称：</span>
          <el-input class="el-search" v-model="customer" placeholder="客户名称"></el-input>
        </div>
        
        <el-button class="search-btn" @click="toSearch">查询结果</el-button>
      </div>
    </div>
    <!-- 退款列表 -->
    <div class="repair-list">
      <div class="head">
        <h2 class="title">
          <i></i>
          <span>数据列表</span>
        </h2>
      </div>
      <!-- 表格 -->
      <el-table
        v-loading='loading'
        ref="multipleTable"
        :data="serviceList"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column align="center" type="selection" width="55"></el-table-column>
        <el-table-column align="center" prop='serviceID' label="编号" width="100"></el-table-column>
        <el-table-column align="center" prop="customer" label="客户名称"></el-table-column>
        <el-table-column align="center" prop="phone" label="联系电话" width="160"></el-table-column>
        <el-table-column align="center"  label="订单编号" width="160">
           <template slot-scope="scope">
                        <span class="orderCode" @click="watchOrderDetail(scope.row)">{{scope.row.orderCode}}</span>
                    </template>
        </el-table-column>
        <el-table-column align="center" prop="content" label="退款内容"></el-table-column>
        <el-table-column align="center" prop="createTime" label="提交时间" width="180"></el-table-column>
        <el-table-column align="center" label="处理状态" width="120">
          <template slot-scope="scope">{{ statusFilter(scope.row.status) }}</template>
        </el-table-column>
        <el-table-column align="center" prop="address" label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click='toDetail(scope.row)' type="text" size="small">查看</el-button>
            <el-button @click='deleteOne(scope.row)' type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog width='600px' title="退款详情" :visible.sync="showDetail">
      <!-- <serviceListDetail 
        :list1='details.detail1' 
        :list2='details.detail2' 
        :list3='details.detail3'
        :status='details.status'
        :msg='details.remark' /> -->
        <div v-loading='loading' class="service-list-detail">
          <table>
            <tr v-for='(item,index) in details.detail1' :key="index">
              <td>{{item.name}}</td>
              <td>{{item.val}}</td>
            </tr>
            <tr>
              <td>图片</td>
              <td>
                <ul>
                  <li v-for='(item,index) in details.detail3' :key="index">
                    <img width='100' height='100' :src="item">
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>处理备注</td>
              <td><el-input :readonly="details.status == 3" type="textarea" resize='none' v-model='details.remark' /></td>
            </tr>
            <tr v-show='details.status > 2' v-for='(item,index) in details.detail2' :key="index">
              <td>{{item.name}}</td>
              <td>{{item.val}}</td>
            </tr>
          </table>
          <div class="btn-wrapper">
            <el-button :loading='btnLoading' @click='handleService(2)' v-show='details.status < 2' type="danger">拒绝</el-button>
            <el-button :loading='btnLoading' @click='handleService(3)' v-show='details.status < 2' type="success">已处理</el-button>
          </div>
        </div>
    </el-dialog>
    <!-- 多选操作 -->
    <div style="margin-top: 20px; margin-left: 50px">
        <!-- <el-button @click="getListByStatus()">处理中</el-button>
        <el-button @click="getListByStatus()">已处理</el-button> -->
        <el-button :loading='btnLoading' @click="deleteItems">批量删除</el-button>
    </div>
    <!--分页-->
    <div class='pagination-wrapper'>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync='currentPage'
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
          center
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
// import serviceListDetail from './serviceListDetail.vue'

export default {
  components: {
    headerNotice,
    // serviceListDetail
  },
  props: {},
  data() {
    return {
      loading: false,
      btnLoading: false,
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      showDetail: false,
      customer: '',
      saleman: '',
      serviceList: [],
      multipleSelection: [],
      details: {
        detail1: [],
        detail2: [],
        detail3: [],
        status: 1,
        remark: ''
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    toSearch() {
      let params = {
        Customer: this.customer,
        Salesman: this.saleman,
        MaxResultCount: this.pageSize,
        SkipCount: 0
      }
      this.getService(params)
      this.currentPage = 1
    },
    toDetail(row) {
      this.showDetail = true
      this.getServiceDetails({serviceid: row.serviceID})
    },
        //查看订单
    watchOrderDetail(row) {
      this.$router.push({
        path: "/orderDetail",
        query: {
          orderCode: row.orderCode
        }
      });
    },
    //获取公告列表
    getService(params) {
      let self = this;
      self.loading = true
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminServices/GetService",
        params: params,
        success(res) {
          // console.log(res);
          self.serviceList = res.items
          self.totalCount = res.totalCount
          self.loading = false
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    // 查看详情
    getServiceDetails(params) {
      let self = this;
      self.loading = true
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminServices/GetServiceDetails",
        params: params,
        success(res) {
          // console.log(res);
          self.serviceDetail = self.dealServiceDetail(res)
          self.loading = false
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    //处理详情数据
    dealServiceDetail(data) {
      this.details.detail1 = [
        {name: '编号', val: data.serviceID},
        {name: '客户名称', val: data.customer},
        {name: '提交时间', val: data.createTime},
        {name: '处理状态', val: this.statusFilter(data.status)},
        {name: '退款描述', val: data.content},
        {name: '退款原因', val: data.address},
      ]
      this.details.detail2 = [
        {name: '处理人员', val: data.contactUser},
        {name: '处理时间', val: data.handleTime}
      ]
      this.details.detail3 = this.dealImgUrl(data.images)
      this.details.status = data.status
      this.details.remark = data.remark
    },
    // 处理图片地址
    dealImgUrl(data) {
      let arr = [] 
      data.forEach((item) => {
        arr.push(this.$store.state.apiUrl + item)
      })
      // console.log(arr)
      return arr
    },
    // 更改处理状态
    handleService(status) {
      let self = this;
      // self.loading = true
      let data = {
        serviceID: self.details.detail1[0].val,
        remark: self.details.remark,
        status: status
      }
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminServices/HandleService",
        data: data,
        success(res) {
          // console.log(res);
          // self.serviceDetail = self.dealServiceDetail(res)
          // self.loading = false
          self.$message({
            showClose: true,
            message: "操作成功！",
            type: "success"
          });
          self.showDetail = false
          self.toSearch()
        },
        fail(res) {
          // self.loading = false;
        }
      });
    },
    //批量删除
    delServiceVol(data) {
      this.$confirm('此操作将永久删除该项目, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
              let self = this;
              self.btnLoading = true
              $http.POST({
                url:
                  this.$store.state.apiUrl +
                  "/api/services/app/AdminServices/DelServiceVol",
                data: data,
                success(res) {
                  // console.log(res);
                  self.$message({
                    showClose: true,
                    message: "操作成功！",
                    type: "success"
                  });
                  self.btnLoading = false;
                  self.toSearch()
                },
                fail(res) {
                  self.btnLoading = false;
                }
              })
        }).catch(() => {
              this.$message({
                  type: 'info',
                  message: '已取消删除'
              });
          });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 点击删除单个
    deleteOne(row) {
      this.delServiceVol({serviceIDs: [row.serviceID]})
    },
    // 点击批量删除
    deleteItems() {
      if(!this.multipleSelection.length) {
        this.$message.error('请至少勾选一项')
        return
      }
      let serviceIDs = []
      this.multipleSelection.forEach((item) => {
        serviceIDs.push(item.serviceIDs)
      })
      this.delServiceVol({serviceIDs: serviceIDs})
    },
    //一页显示多少个
    handleSizeChange(val) {
      this.maxResultCount = val;
      let params = {
          MaxResultCount: val,
          Customer: this.customer,
          Saleman: this.saleman
      };
      this.getService(params);
    },
    //跳转到指定页
    handleCurrentChange(val) {
      let skipCount = (val - 1) * this.pageSize;
      let params = {
          SkipCount: skipCount,
          MaxResultCount: this.pageSize,
          Customer: this.customer,
          Saleman: this.saleman
      };
      this.getService(params);
    },
    statusFilter(status) {
      return status == 1 ? "待处理" : (status == 2 ? '拒绝' : '已处理');
    }
  },
  created() {
    this.getService({
      MaxResultCount: this.pageSize
    })
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.service-list {
  // 搜索
  .seach-box {
    border: 1px solid rgba(228, 228, 228, 1);
    margin: 20px 50px;
    .title-wrapper {
      // display: flex;
      // align-items: center;
      // justify-content: space-between;
      height: 50px;
      background-color: rgba(243, 243, 243, 1);
      border-bottom: 1px solid rgba(228, 228, 228, 1);
      padding: 0 20px;
    }
    .title {
      display: flex;
      height: 50px;
      align-items: center; 
      font-weight: 400;
      // i:first-child {
      //   width: 18px;
      //   height: 18px;
      //   background: green;
      // }
    }
    .input-wrapper {
      display: flex;
      align-items: center;
      height: 60px;
      padding-left: 40px;
      .el-search {
        width: 180px;
      }
      .saleman-wrapper {
        margin-left: 40px;
        margin-right: 40px;
      }
    }
  }

  // 退款列表
  .repair-list {
    margin: 0 50px;
    border: 1px solid rgba(228, 228, 228, 1);
    font-weight: 400;
    .head {
      // display: flex;
      // align-items: center;
      // justify-content: space-between;
      background-color: rgba(243, 243, 243, 1);
      border-bottom: 1px solid rgba(228, 228, 228, 1);
      .title {
        display: flex;
        align-items: center;
        height: 50px;
        font-weight: 400;
        padding-left: 20px;
        // i:first-child {
        //   width: 18px;
        //   height: 18px;
        //   background: green;
        // }
      }
    }
  }
  .pagination-wrapper {
    text-align: center;
    margin-top: 20px;
  }
  .service-list-detail {
    td {
      height: 40px;
      width: 470px;
      padding: 5px 10px;
      border: 1px solid #e4e4e4;
      border-collapse: collapse;
      word-break: break-all;
      &:first-child {
        width: 120px;
        padding: 0;
        text-align: center;
        vertical-align: middle;
      }
      input {
        box-shadow: none;
        width: 300px;
      }
      // &:nth-of-child(2) {
      //   margin-top: 
      // }
      li {
        display: inline-block;
        margin-right: 5px;
      }
    }
    .btn-wrapper {
        text-align: center;
        margin: 30px auto;
      }
  }
}
</style>